export const formatCurrency = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '—';
  const num = parseFloat(String(value));
  if (isNaN(num)) return '—';
  return `R$ ${num.toFixed(2).replace('.', ',')}`;
};

export const formatDate = (iso: string): string => {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const formatShortDate = (iso: string): string => {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
  });
};

export const formatDateTime = (iso: string): string => {
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const normalizeText = (text: string): string => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
};

export const parseCurrencyInput = (value: string): string => {
  return value.replace(',', '.').trim();
};
